import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as o, normalizeClass as l, createElementVNode as r } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCornerDownRight",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.146 4.646a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L8.793 8l.5-.5-.5-.5-1.647-1.646a.5.5 0 0 1 0-.708Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ r("path", {
  d: "M2.5 2a.5.5 0 0 0-1 0v3.5A2.5 2.5 0 0 0 4 8h4.793l.5-.5-.5-.5H4a1.5 1.5 0 0 1-1.5-1.5V2Z",
  fill: "currentColor"
}, null, -1), h = [
  _,
  u
];
function m(a, f, i, p, g, e) {
  return o(), n("svg", {
    "aria-label": i.ariaLabel,
    class: l([e.iconSizeClass, "d-icon d-icon--corner-down-right"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Corner Down Right",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const b = /* @__PURE__ */ d(s, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=corner-down-right.js.map
